import { SearchBaseModel } from '../commonModels';

export class GarageSearchModel extends SearchBaseModel {
    garageId: number;
    name: string;
    serviceCompanyId: number;
    city: string;
    street: string;
    voivodeship: string;
    isActive: boolean;
    isTyreSendingBlocked: boolean;
    isSupplierOnly: boolean;
    isTyreSale: boolean;
    isTyreDispatch: boolean;
    isOnVacation: boolean;
    chp: boolean;
    appointment: number;
    CustomerId: number;
    IsMechanicalOnly: boolean;
    IsNotEmpty: boolean;
    IsActiveServiceCompany: boolean;
    ShowAllGarages: boolean;
    HasOpenOrders: boolean;
    ServiceCompanyTypeId: number;
    IsNotInventoriedDeposites: boolean;
    HesInventoryDocument: boolean;
    //do sprawdzenia czy mozna wyłaczyc IsTyreSendingBlocked dla garaży w których już jest depozyt dla danego samochodu.
    CarId: number;
    //Możliwośc wyszukiwania garaży ze stanowiskami online
    IsEnableOnlineGarageVisitsPlace: boolean;

    constructor() {
        super();
        this.ShowAllGarages = false;
        this.street = null;
        this.garageId = null;
        this.name = null;
        this.serviceCompanyId = null;
        this.city = null;
        this.voivodeship = null;
        this.isActive = null;
        this.isTyreSendingBlocked = null;
        this.isSupplierOnly = null;
        this.isTyreSale = null;
        this.isTyreDispatch = null;
        this.isOnVacation = null;
        this.chp = null;
        this.appointment = null;
        this.CustomerId = null;
        this.IsMechanicalOnly = null;
        this.IsNotEmpty = null; 
        this.IsActiveServiceCompany = null;
        this.HasOpenOrders = null;
        this.ServiceCompanyTypeId = null;
        this.IsNotInventoriedDeposites = null;
        this.HesInventoryDocument = null;
    }
}
